import facebook from './facebook.svg';
import github from './github.svg';
import google from './google.svg';
import linkedin from './linkedin.svg';
import microsoft from './microsoft.svg';
import plone from '@plone/volto/icons/plone.svg';
import oidc from './openid.svg';
import twitter from './twitter.svg';

const icons: Record<
  | 'facebook'
  | 'github'
  | 'google'
  | 'linkedin'
  | 'microsoft'
  | 'oidc'
  | 'plone'
  | 'twitter',
  string
> = {
  facebook,
  github,
  google,
  linkedin,
  microsoft,
  oidc,
  plone,
  twitter,
};

export default icons;
